// styles
import Button from '@sdb/ui/atoms/Button';
import { Box, BoxProps, styled } from '@mui/material';

export const StyledHeader = styled(Box)({
  zIndex: 40,
  width: '100%',
  minHeight: 50
});

export const Top = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'showDateNavigation'
})<BoxProps & { showDateNavigation?: boolean }>(
  ({ theme, showDateNavigation }) => ({
    display: 'grid',
    gridTemplateColumns: showDateNavigation ? '1fr 1fr 1fr' : '1fr 1fr',
    alignItems: 'center',
    gap: theme.spacing(4),
    paddingBottom: theme.spacing(5),
    position: 'relative',
    gridTemplateAreas: showDateNavigation
      ? `'leftContent dateNavigation rightContent'`
      : `'leftContent rightContent'`,

    '& > :nth-of-type(1)': {
      gridArea: 'leftContent'
    },
    '& > :nth-of-type(2)': {
      gridArea: 'dateNavigation'
    },
    '& > :nth-of-type(3)': {
      gridArea: 'rightContent'
    },

    [theme.breakpoints.down('medium')]: {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateAreas: `
      'dateNavigation dateNavigation'
      'leftContent rightContent'
    `
    },

    '.MuiAutocomplete-root': {
      minWidth: 200
    }
  })
);

export const DateNavigationContainer = styled(Box)({
  justifySelf: 'center'
});

export const PlanUnitSelectorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(6),
  flexWrap: 'wrap',
  width: 550
}));

export const IconContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['iconColor', 'iconSize'].includes(prop)
})<{ iconColor?: string; iconSize?: 'SMALL' | 'MEDIUM' | 'LARGE' }>(
  ({ theme, iconColor, iconSize = 'SMALL' }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    height: '100%',

    svg: {
      width:
        iconSize == 'SMALL' ? '18px' : iconSize == 'MEDIUM' ? '21px' : '40px',
      height: '100%',
      color: iconColor,
      display: 'flex',
      alignItems: 'center'
    }
  })
);

export const StyledLargeButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  borderRadius: '32px',
  lineHeight: 'normal'
}));
